import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Item } from "../../models/item.model";
import {
  PushNotificationService,
  AlertService,
} from "../../services/service.index";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

@Component({
  selector: "app-push-notifications",
  templateUrl: "./push-notifications.component.html",
  styles: [],
})
export class PushNotificationsComponent implements OnInit, OnDestroy {
  item = new Item("", "", "");

  private unsubscribe$ = new Subject<void>();
  private unsubscribe2$ = new Subject<void>();
  message = false;
  disabledPush = false;

  constructor(
    public pushNotification: PushNotificationService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.getMessage();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.unsubscribe2$.next();
    this.unsubscribe2$.complete();
  }

  push(form: NgForm) {
    this.item.itemId = "1";
    if (form.valid) {
      this.item.name = form.value.name;
      this.item.description = form.value.description;
      this.pushNotification
        .postPushNotificationAll(this.item)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (pushRes: any) => {
            // console.log(pushRes);
          },
          (error) => {
            // console.log(error);
          }
        );
      Swal.fire(
        "Notificación enviada!",
        "Su notificación ha sido enviada a sus usuarios.",
        "success"
      );
    }
    form.reset();
  }

  pushToActive(form: NgForm) {
    console.log("clicked");
    this.item.itemId = "1";
    if (form.valid) {
      this.item.name = form.value.name;
      this.item.description = form.value.description;

      this.pushNotification
        .postPushNotificationToActives(this.item)
        .pipe(takeUntil(this.unsubscribe2$))
        .subscribe(
          (pushRes: any) => {
            // console.log(pushRes);
          },
          (error) => {
            console.log(error);
          }
        );
      Swal.fire(
        "Notificación enviada!",
        "Su notificación ha sido enviada a sus usuarios.",
        "success"
      );
    }
    form.reset();
  }

  getMessage() {
    this.alertService.getAdminMessage().then((res) => {
      res.subscribe((alert: any) => {
        this.disabledPush = alert.disabledPush;
      });
    });
  }
}
